<template>
  <v-card flat :style="`height: ${ windowSize.y }px; position: 'relative'`" class="pa-1 product-view" v-resize="onResizeHandler">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pa-0">
      <v-form ref="pickForm" v-on:submit.prevent>
        <v-row>
          <v-col cols="6" class="pb-0 pt-0 font-weight-bold">{{ orderModel.number }}</v-col>
          <v-col cols="6" class="pb-0 pt-0 text-right">{{ $t('message.order.delivery') }}: {{ orderModel.deliverydate | dateFormat }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-0 pl-3 font-weight-bold">{{ orderModel.customer_name || '' }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="8" class="pt-0 pr-0 pb-0 mt-1">
            <v-text-field outlined dense hide-details v-model="scanCode" flat autocomplete="off"
              ref="scanFocus" @change="getRespectiveProductOrder" :loading="productLoading"
            :placeholder="$t('message.order.scanProduct')"></v-text-field>
          </v-col>
          <v-col cols="4" class="pt-0 font-weight-bold text-right pr-0 pb-0 mt-1">
            {{ grandTotal | absoluteNumber }}
          </v-col>
          <v-col cols="12" class="pt-1 pb-1 font-weight-bold" v-if="productFound">
            {{ productInfo.productname || '' }}
          </v-col>
          <v-col cols="8" class="pt-0 highlight" v-if="productFound">
            <v-row>
              <v-col cols="6" class="pa-0 text-left font-weight-bold">{{ $t('message.order.location') }}</v-col>
              <v-col cols="6" class="pa-0 pr-2 text-right font-weight-bold">{{ $t('message.order.avail') }}</v-col>
            </v-row>
            <v-row v-for="(location, i) in productInfo.locations" :key="i">
              <v-col cols="6" class="pa-0 text-left text-truncate" :title="location.locationname">{{ location.locationname }}</v-col>
              <v-col cols="6" class="pa-0 text-right text-truncate" :title="location.availableqty">{{ location.availableqty | absoluteNumber }}</v-col>
            </v-row>
          </v-col>
          <template v-if="productFound && (productInfo.producttype === 'product')">
            <v-col cols="8" class="pt-0 pr-0 pb-0 mt-1" >
              <v-text-field outlined dense hide-details v-model="selectedLocation" flat autocomplete="off"
                :rules="$_requiredValidation" @change="checkIfLocationValid" :loading="loadingLocation"
                ref="locationRef" :placeholder="$t('message.product.scanLoc')"></v-text-field>
            </v-col>
            <v-col cols="8" class="pt-0 pr-0 pb-0 mt-1" v-if="productInfo.isbatch">
              <v-text-field outlined dense hide-details v-model="selectBatch" flat @change="checkTheBatchnumber" autocomplete="off"
                :rules="productInfo.producttype === 'product' ? $_requiredValidation : []" :placeholder="$t('message.product.batch')" ref="batchRef"
                :loading="loadingBatch"></v-text-field>
            </v-col>
          </template>
        </v-row>
        <v-row v-if="productFound">
          <v-col cols="9" class="pa-1">
            <v-row>
              <v-col cols="3" class="text-center pa-0" @click="decreaseQty">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-text-field outlined dense hide-details type="number" class="text-right" v-model="pickQty"
                  autocomplete="off" ref="qtyRef" :rules="$_qtyValidation" :placeholder="$t('message.product.qty')"></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center pa-0" @click="increaseQty">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" class="pa-1 mt-1">
            <v-btn color="primary" dark small @click="pickQtyOnOrder" :loading="saveLoading">
              {{ $t('message.order.pick') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <!-- PICKED PRODUCTS -->
    <v-card-text tabindex="0" class="highlight pt-0 pb-0 pl-1 mt-2">
      <v-row>
        <v-col cols="3" class="pa-0 pl-3 font-weight-bold">{{ $t('message.order.picked') }}:</v-col>
        <v-col cols="3" class="pa-0 pr-2 text-center font-weight-bold">{{ $t('message.order.location') }}</v-col>
        <v-col cols="2" class="pa-0 text-right font-weight-bold">{{ $t('message.product.qty') }}</v-col>
        <v-col cols="4" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.price') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in listOfProducts.pickedproducts" :key="index">
        <v-col cols="3" class="pa-0 pl-3 text-truncate" :title="product.number" :class="{ 'pb-1': (index === listOfProducts.pickedproducts.length - 1)}">
          <span v-if="product.ispackage"><b>{{ product.number }}</b></span>
          <span v-else>{{ product.number }}</span>
        </v-col>
        <v-col cols="3" class="pa-0 text-center text-truncate" :title="product.locationname">{{ product.locationname }}</v-col>
        <v-col cols="2" class="pa-0 text-right text-truncate" :title="product.qty">{{ product.qty | absoluteNumber }}</v-col>
        <v-col cols="4" class="pa-0 pl-3 text-right text-truncate">
          {{ product.total | absoluteNumber }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$router.push(`/store_sale/${orderId}`)">{{ $t('message.login.back') }}</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {},
      scanCode: '',
      windowSize: {
        x: 0,
        y: 0
      },
      productFound: false,
      productInfo: {},
      pickQty: '',
      listOfLocations: [],
      selectedLocation: '',
      selectBatch: '',
      saveLoading: false,
      loadingBatch: false,
      isAllPicked: false,
      batchLocations: [],
      productLoading: false,
      loadingLocation: false,
      exchangeRate: 0,
      grandTotal: 0
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.store_id
    this.getOrderInfo()
    this.getMaterialProducts()
    this.onResizeHandler()
    this.focusField('scanFocus')
  },
  watch: {
    pickQty (val) {
      let pickedQty = +this.$format.replaceCommaWithDot(this.pickQty || 0)
      let locations = this.listOfLocations
      if (this.selectedLocation) {
        let getOnStockValue = locations.find(x => x.locationname === this.selectedLocation)
        if (getOnStockValue) {
          if (this.productInfo.isbatch && getOnStockValue.batches) {
            let getBatchQty = getOnStockValue.batches
            let getObj = getBatchQty.find(x => x.batchnumber === this.selectBatch)
            if (getObj) {
              if (pickedQty > getObj.onstock) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
                setTimeout(() => {
                  this.pickQty = getObj.onstock
                })
              }
            }
          } else {
            let onstock = getOnStockValue.availableqty
            if (pickedQty > onstock) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
              setTimeout(() => {
                this.pickQty = onstock
              })
            }
          }
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.noLocFound') })
          setTimeout(() => {
            this.pickQty = ''
            this.selectedLocation = ''
            this.focusField('moreLocation')
          })
        }
      }
    }
  },
  methods: {
    getOrderInfo () {
      let model = {
        'expand': [{
          'select': ['name', 'invoicecurrencyid'],
          'model': 'Customer',
          'on_field': 'id',
          'on_parent_field': 'customerid'
        }],
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'orders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
            this.getExchangeRate()
          }
        })
    },
    getMaterialProducts () {
      this.$api.execute('get', `/ordermaterials/get_materials/${this.orderId}`)
        .then((response) => {
          if (response.data) {
            this.listOfProducts = response.data
            this.selectedLocation = ''
            this.selectBatch = ''
            this.pickQty = ''
            this.productInfo = {}
            this.scanCode = ''
            this.productFound = false
            this.focusField('scanFocus')
            let items = this.$format.cloneVariable(this.listOfProducts.pickedproducts)
            this.grandTotal = 0
            items.map(x => {
              if (!x.packageid && !x.orderindex && !x.mainpackageid) {
                this.grandTotal += (x.total || 0)
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getRespectiveProductOrder () {
      this.selectedLocation = ''
      if (this.scanCode) {
        this.productLoading = true
        this.$api.execute('get', `orders/get_product_with_stock/${this.scanCode || ''}`)
          .then((response) => {
            // to clear values
            this.selectBatch = ''
            this.pickQty = ''
            this.batchLocations = []
            const getProduct = response.data
            if (getProduct) {
              this.productInfo = getProduct
              this.productFound = true
              this.listOfLocations = getProduct.locations || []
              if (this.productInfo.producttype === 'work') {
                setTimeout(() => {
                  this.focusField('qtyRef')
                }, 50)
              } else {
                setTimeout(() => {
                  this.focusField('locationRef')
                }, 50)
              }
            } else {
              this.productInfo = {}
              this.productFound = false
              this.listOfLocations = []
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.product.noProductFound') })
              this.focusField('scanFocus')
              this.scanCode = ''
            }
          })
          .finally(() => {
            this.productLoading = false
          })
      }
    },
    onResizeHandler () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 40 }
    },
    decreaseQty () {
      if (this.pickQty > 0) this.pickQty--
    },
    increaseQty () {
      if (this.pickQty < 0) this.pickQty = ''
      this.pickQty++
    },
    checkTheBatchnumber () {
      this.pickQty = ''
      this.batchLocations = []
      let products = this.$format.cloneVariable(this.productInfo)
      if (products && products.locations) {
        this.loadingBatch = true
        let getStock = products.locations.find(x => x.locationname === this.selectedLocation)
        if (getStock) {
          let getBatches = getStock.batches
          if (getBatches) {
            let getBatchWithStock = getBatches.find(x => x.batchnumber === this.selectBatch)
            if (getBatchWithStock) {
              this.focusField('qtyRef')
            } else {
              this.selectBatch = ''
              this.focusField('batchRef')
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.notValidBatch') })
            }
          }
        } else {
          this.selectBatch = ''
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.notValidBatch') })
        }
        this.loadingBatch = false
      }
    },
    async pickQtyOnOrder () {
      let pickedQty = this.$format.replaceCommaWithDot(this.pickQty || 0)
      if (this.$refs.pickForm.validate() && pickedQty > 0) {
        this.saveLoading = true
        let locations = this.listOfLocations
        let getOnStock = locations.find(x => x.locationname === this.selectedLocation)
        let warehouseid = 0
        let locationid = 0
        if (getOnStock) {
          locationid = getOnStock.locationid
          warehouseid = getOnStock.warehouseid
        }
        const productObj = this.$format.cloneVariable(this.productInfo)
        productObj.qty = pickedQty
        productObj.pickedqty = pickedQty
        productObj.invoiceqty = pickedQty
        productObj.batchnumber = this.productInfo && this.productInfo.isbatch ? this.selectBatch : null
        productObj.locationid = locationid
        productObj.warehouseid = warehouseid
        productObj.number = productObj.productnumber
        productObj.producttext = productObj.productname

        let suppliers = await this.getProductSuppliers(productObj.productid)
        let supplierid = 0
        if (suppliers) {
          let getMainSupplier = suppliers.find(x => x.ismain)
          supplierid = getMainSupplier ? getMainSupplier.supplierid : 0
          const getSupplier = suppliers.find(x => x.supplierid === supplierid)
          if (getSupplier && getSupplier.realcostnok) {
            productObj.costprice = getSupplier.realcostnok
          }
        }

        productObj.supplierid = supplierid

        // get sales price value from customer matrix
        let salesPriceFromCustomer = productObj.salesprice
        const getSalesPrice = await this.getCustomerPrice(productObj)
        if (getSalesPrice) {
          salesPriceFromCustomer = getSalesPrice
        }

        let getDiscount = await this.getDiscountValue(productObj.productid)
        getDiscount = getDiscount && getDiscount.data ? getDiscount.data : {}

        let exchangeAmt = 0
        if (this.exchangeRate) exchangeAmt = this.exchangeRate

        const costPrice = exchangeAmt ? (productObj.costprice / exchangeAmt) || '' : ''
        const salesPrice = exchangeAmt ? (salesPriceFromCustomer / exchangeAmt) || '' : ''
        const discount = (getDiscount && getDiscount.discount) ? getDiscount.discount : 0
        productObj.price = salesPrice
        productObj.costprice = costPrice
        productObj.discount = discount
        productObj.total = productObj.qty * salesPrice
        if (discount) {
          let rbtValue = (productObj.total * discount) / 100
          productObj.total = productObj.total - rbtValue
        }

        productObj.dg = this.dgCalculationFormula(costPrice, salesPrice, discount)
        let model = [productObj]
        this.$api.execute('post', `ordermaterials/update_materials/${this.orderId}?fromPwa=true`, model)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
            this.getMaterialProducts()
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    getDiscountValue (productId) {
      return this.$api.execute('get', `discountgroups/get_by_product_for_order/${productId}?order_id=${this.orderId}`)
    },
    getExchangeRate () {
      return new Promise((resolve, reject) => {
        const currencyId = this.orderModel.invoicecurrencyid || this.orderModel.customer_invoicecurrencyid
        this.$api.execute('get', `currencies/get_exchange_rate/${currencyId}`)
          .then((result) => {
            this.exchangeRate = result.data
            resolve(result)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getCustomerPrice (product) {
      return new Promise((resolve, reject) => {
        this.$api.execute('get', `customernetprices/get_for_sale_order/${this.orderId}/${product.productid}`)
          .then((result) => {
            let model = result.data
            if (model && model.salesprice) {
              if (model.salesprice > model.costprice) resolve(model.salesprice)
              else resolve(model.costprice)
            } else {
              resolve(product.salesprice)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getProductSuppliers (productid) {
      return new Promise((resolve, reject) => {
        let query = {
          'expand': [{
            'select': ['name'],
            'model': 'Customer',
            'on_field': 'id',
            'on_parent_field': 'supplierid'
          }],
          filter: `productid eq ${productid}`
        }
        this.$api.execute('post', '/productsuppliers/query', query)
          .then((result) => {
            resolve(result.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    dgCalculationFormula (price, salesprice, discount) {
      // FORMULA
      // (price - product costprice) / price * 100 => without discount
      // If Discount
      // price * (100 - discount) / 100
      // (result - costprice) / result * 100
      let getDGValue = 0
      getDGValue = price > 0 ? ((salesprice - price) / salesprice) * 100 : 0
      if (discount && discount > 0) {
        let getResult = +salesprice * (100 - discount) / 100
        let dgValue = ((getResult - price) / getResult) * 100
        getDGValue = dgValue
      }
      return (isNaN(getDGValue) ? 0 : (getDGValue || 0))
    },
    checkIfLocationValid () {
      this.loadingLocation = true
      this.pickQty = ''
      let locations = this.listOfLocations
      let getOnStockValue = locations.find(x => x.locationname === this.selectedLocation)
      if (!getOnStockValue) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.noLocFound') })
        setTimeout(() => {
          this.pickQty = ''
          this.selectedLocation = ''
        })
      } else {
        const qty = +this.$format.replaceCommaWithDot(this.pickQty)
        if (this.productInfo.isbatch) {
          let getBatch = getOnStockValue.batches.find(x => x.batchnumber === this.selectBatch)
          if (getBatch) {
            if (qty > getBatch.onstock) this.pickQty = getBatch.onstock
          }
          this.focusField('batchRef')
        } else {
          if (qty > getOnStockValue.availableqty) this.pickQty = getOnStockValue.availableqty
          this.focusField('qtyRef')
        }
      }
      this.loadingLocation = false
    },
    focusField (value) {
      requestAnimationFrame(() => {
        if (this.$refs[value]) {
          setTimeout(() => {
            this.$refs[value].focus()
          })
        }
      })
    },
    clearPickedQty () {
      this.pickQty = ''
    }
  }
}
</script>
